import styled from '@emotion/styled';
import { Box } from '@qga/roo-ui/components';
import { themeGet } from 'styled-system';

export const ExclusiveInclusionsWrapper = styled(Box)`
  display: grid;
  grid-template-columns: 1fr;

  ${themeGet('mediaQueries.0')} {
    grid-template-columns: 1fr 1fr;
    gap: 0 ${themeGet('space.4')};
  }

  ${themeGet('mediaQueries.1')} {
    margin-right: ${themeGet('space.2')};
    max-width: 820px;
    min-width: 820px;
  }
`;

export const ExclusiveInclusionSeparator = styled(Box)`
  ${themeGet('mediaQueries.0')} {
    grid-template-columns: 1fr 1fr;
    border-bottom: 1px solid ${themeGet('colors.greys.alto')};
    grid-column-start: span 2;
  }
`;

export const ExclusiveInclusion = styled(Box)`
  display: flex;
  flex-direction: column;
  padding: ${themeGet('space.2')} ${themeGet('space.0')};

  ${themeGet('mediaQueries.0')} {
    padding: ${themeGet('space.4')} ${themeGet('space.0')};
  }
`;

export const ExclusiveInclusionTitle = styled(Box)`
  display: flex;
  align-items: flex-start;
  gap: ${themeGet('space.2')};
`;
